(function () {
    'use strict';

    // @ngInject
    function PricingPlansServiceCtor(AccountsManager, Enums, $translate, PubSubService, $timeout) {
        this.AccountsManager = AccountsManager;
        this.Enums = Enums;
        this.$translate = $translate;
        this.$timeout = $timeout;

        this.tierTypes = {
            basic: 'basic',
            medium: 'medium',
            top: 'top'
        };

        PubSubService.ventMyBitchUp(this);
    }

    Services.PricingPlansService = Class({
        constructor: PricingPlansServiceCtor,

        getAvailablePricingPlans: function getAvailablePricingPlans(company, promoCode) {
            return this.AccountsManager.getAvailablePricingPlans(company.account_id, promoCode).then(function onSuccess(resp) {
                var pricingPlans = angular.copy(resp.data);

                pricingPlans.forEach(function pricingPlanIter(currPricingPlan) {
                    this.addAdditionalDataForPlanViewModel(currPricingPlan);
                }.bind(this));

                pricingPlans.sort(this._planTypePredicateFunction);

                // stupid hack..must give directives time to load and register
                this.$timeout(function() {
                    this.trigger(this.Enums.PubSubTriggers.gotPricingPlans, {pricingPlans: pricingPlans});
                }.bind(this), 100);

                return pricingPlans;
            }.bind(this));
        },

        addAdditionalDataForPlanViewModel: function addAdditionalDataForPlanViewModel(pricingPlan) {

            pricingPlan.isLifetime = pricingPlan.plan_type === this.Enums.pricingPlanTypes.free || pricingPlan.plan_type === this.Enums.pricingPlanTypes.lifetime;

            if (pricingPlan.tier === this.tierTypes.basic){
                pricingPlan.tierTitle = pricingPlan.tierTitle = this.$translate.instant('SETTINGS.SUBSCRIPTION.TIERS._BASIC_');
            } else if (pricingPlan.tier === this.tierTypes.medium){
                pricingPlan.tierTitle = pricingPlan.tierTitle = this.$translate.instant('SETTINGS.SUBSCRIPTION.TIERS._MEDIUM_');
            } else if (pricingPlan.tier === this.tierTypes.top){
                pricingPlan.tierTitle = pricingPlan.tierTitle = this.$translate.instant('SETTINGS.SUBSCRIPTION.TIERS._TOP_');
            }

            if (pricingPlan.tier === this.tierTypes.medium && pricingPlan.plan_type === this.Enums.pricingPlanTypes.annual) {
                pricingPlan.recommended = true;
            }

            if (pricingPlan.plan_type === this.Enums.pricingPlanTypes.monthly) {
                pricingPlan.planTypeTitle = this.$translate.instant('SETTINGS.SUBSCRIPTION.PLAN_TYPE._MONTLY_');
            } else {
                pricingPlan.planTypeTitle = this.$translate.instant('SETTINGS.SUBSCRIPTION.PLAN_TYPE._ANNUAL_');
            }

            if(pricingPlan.plan_type === this.Enums.pricingPlanTypes.manual){
                if (pricingPlan.monthly_payment_period === 1) {
                    pricingPlan.paymentFrequency = this.$translate.instant('SETTINGS.SUBSCRIPTION.PLAN_TYPE._PER_MONTH_ ');
                } else if (pricingPlan.monthly_payment_period === 12){
                    pricingPlan.paymentFrequency = this.$translate.instant('SETTINGS.SUBSCRIPTION.PLAN_TYPE._PER_YEAR_');
                } else if ((pricingPlan.monthly_payment_period % 12 === 0 )) {
                    pricingPlan.paymentFrequency = (pricingPlan.monthly_payment_period / 12).toString() + ' ' + this.$translate.instant('SETTINGS.SUBSCRIPTION.PLAN_TYPE._PER_YEARS_');
                } else {
                    pricingPlan.paymentFrequency = pricingPlan.monthly_payment_period + ' ' + this.$translate.instant('SETTINGS.SUBSCRIPTION.PLAN_TYPE._PER_MONTHS_');
                }
            }

        },

        _planTypePredicateFunction: function _planTypePredicateFunction(planA, planB) {
            var planTypeWeight= {
                annual: 1,
                monthly: 2
            };

            return planTypeWeight[planA.plan_type] - planTypeWeight[planB.plan_type];
        },
    });
}());
